document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('#slideshow-custom .slideshow');
  const slides = container.querySelectorAll('.slideshow__slide');
  const btnNext = document.querySelector('.slideshow-nav button[name="next"]');
  const btnPrev = document.querySelector('.slideshow-nav button[name="prev"]');

  if (!container || slides.length === 0) return;

  let currentIndex = 0;

  function goToSlide(index) {
    if (index < 0) index = slides.length - 1;
    if (index >= slides.length) index = 0;

    slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === index);
      slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
    });

    currentIndex = index;
  }

  btnNext?.addEventListener('click', () => {
    goToSlide(currentIndex + 1);
  });

  btnPrev?.addEventListener('click', () => {
    goToSlide(currentIndex - 1);
  });

  // Init
  goToSlide(0);
});